module.exports = __webpack_public_path__ + "static_pc/img/25.9eb73d66.png";